import React from "react"
import moment from "moment"

import MDBox from "components/MDBox"
import MDTypography from "components/MDTypography"

import {
  noteTypography,
  titleTypography,
  descriptionTypography,
} from "shared/styles/style"

import { renderBackgroundColorLXO } from "shared/utils/common"
import MDButton from "components/MDButton"
import { useMarkDoneMutation } from "shared/redux/endpoints/lxo/teacherManagement"

const TodoItemLXO = ({ data, setSnackbar, onDone }) => {
  const [triggerMarkDone, { isLoading }] = useMarkDoneMutation()

  const handlerMarkDone = async () => {
    const res = await triggerMarkDone({ id: data.taskId })
    if (res?.data?.data) {
      setSnackbar({
        color: "success",
        message: res?.data?.data,
        open: true,
      })
      onDone?.({ taskId: data.taskId })
    } else if (res?.error?.data) {
      setSnackbar({
        color: "error",
        message: res?.error?.data,
        open: true,
      })
    }
  }
  return (
    <MDBox
      sx={{
        background: "#fff",
        borderRadius: "15px",
        padding: "24px",
      }}
    >
      <MDTypography sx={{ ...titleTypography() }}>
        {" "}
        {data.taskDescription}
      </MDTypography>
      <MDTypography
        sx={(theme) => ({
          ...noteTypography(theme.breakpoints),
          background: renderBackgroundColorLXO(data.taskType),
          color: "#fff",
          width: "fit-content",
          padding: "4px 8px",
          borderRadius: "8px",
          margin: "12px 0",
        })}
      >
        Type: {data.taskType}
      </MDTypography>
      <MDTypography
        sx={({ breakpoints }) => descriptionTypography(breakpoints)}
      >
        <b>LXO ID:</b> {data.lxoId}
      </MDTypography>
      <MDTypography
        sx={({ breakpoints }) => descriptionTypography(breakpoints)}
      >
        <b>LXO:</b> {data.lxoName}
      </MDTypography>
      <MDTypography
        sx={({ breakpoints }) => descriptionTypography(breakpoints)}
      >
        <b>Center:</b> {data.center}
      </MDTypography>
      <MDTypography
        sx={({ breakpoints }) => descriptionTypography(breakpoints)}
      >
        <b>Month:</b> {data.month}
      </MDTypography>

      <MDTypography
        sx={({ breakpoints }) => descriptionTypography(breakpoints)}
      >
        <b>Due Date:</b> {moment(data.toDate).format("MMM DD,YYYY")}
      </MDTypography>

      {(data?.taskStatus === "To-do" ||
        data?.taskStatus === "Overdue" ||
        data?.taskStatus === "overdue") && (
        <MDButton
          variant="gradient"
          color="info"
          sx={{
            marginLeft: "auto",
            marginTop: "16px",
            // width: "100%",
            display: "flex",
            justifyContent: "flex-end",
          }}
          onClick={handlerMarkDone}
        >
          Mark Done
        </MDButton>
      )}
    </MDBox>
  )
}

export default TodoItemLXO
